// import { Footer } from "@/components/admin-panel/footer";
import { Sidebar } from "@/components/sidebar/sidebar";
import { SheetMenu } from "@/components/sidebar/sheet-menu";
import { useSidebar } from "@/hooks/use-sidebar";
import { useStore } from "@/hooks/use-store";
import { cn } from "@/lib/utils";
import { Link } from "@tanstack/react-router";

export default function UserSidebar({
  children,
}: {
  children: React.ReactNode;
}) {
  const sidebar = useStore(useSidebar, (x) => x);
  if (!sidebar) return null;
  const { getOpenState, settings } = sidebar;
  return (
    <>
      <Sidebar />
      {/* Mobile Header - only visible on mobile */}
      <header className="lg:hidden sticky top-0 z-30 relative flex items-center h-14 px-4 bg-background/95 backdrop-blur border-b border-border/40">
        <div className="z-10">
          <SheetMenu />
        </div>
        <Link to="/portfolio" className="absolute left-1/2 -translate-x-1/2 flex items-center">
          <img
            src="/wealthscale_light.svg"
            alt="WealthScale Logo"
            width={32}
            height={32}
            className="block dark:hidden"
          />
          <img
            src="/wealthscale_dark.svg"
            alt="WealthScale Logo"
            width={32}
            height={32}
            className="hidden dark:block"
          />
        </Link>
        <div className="w-8" />
      </header>
      <main
        className={cn(
          "min-h-screen py-4 px-4 lg:pl-0 lg:pr-4 transition-[margin] duration-300",
          !settings.disabled && (
            !getOpenState() 
              ? "lg:ml-[105px]" 
              : "lg:ml-[105px] lg:ml-[305px]"
          )
        )}
      >
        {children}
      </main>
    </>
  );
}
